<div class="side-panel-card mb-3">
  @if(noDataFound) {
  <div class="side-panel-card mb-3">
    <div class="d-flex w-100  flex-column">
      <div class="mb-2 d-flex">
        <div class="mr-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path
              d="M6.66667 0C3 0 0 3 0 6.66667C0 10.3333 3 13.3333 6.66667 13.3333C10.3333 13.3333 13.3333 10.3333 13.3333 6.66667C13.3333 3 10.3333 0 6.66667 0ZM6.66667 10C6.26667 10 6 9.73333 6 9.33333C6 8.93333 6.26667 8.66667 6.66667 8.66667C7.06667 8.66667 7.33333 8.93333 7.33333 9.33333C7.33333 9.73333 7.06667 10 6.66667 10ZM7.33333 6.66667C7.33333 7.06667 7.06667 7.33333 6.66667 7.33333C6.26667 7.33333 6 7.06667 6 6.66667V4C6 3.6 6.26667 3.33333 6.66667 3.33333C7.06667 3.33333 7.33333 3.6 7.33333 4V6.66667Z"
              fill="#FBA744" />
          </svg>
        </div>
        <div class="w-100">
          <div class="d-flex justify-content-between">
            <span class="f-12 font-weight-600 ">
              Contact details unavailable
            </span>

          </div>
        </div>
      </div>
      <div class="f-12 text-9696">
        No contact details were found in the candidate cv.
      </div>
    </div>
  </div>
  } @else {
      <div class="mb-2 d-flex bb-1 pb-1">
        <div class="mr-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path
              d="M6.66667 0C3 0 0 3 0 6.66667C0 10.3333 3 13.3333 6.66667 13.3333C10.3333 13.3333 13.3333 10.3333 13.3333 6.66667C13.3333 3 10.3333 0 6.66667 0ZM5.33333 10L2 6.66667L2.94 5.72667L5.33333 8.11333L10.3933 3.05333L11.3333 4L5.33333 10Z"
              fill="#68AA86" />
          </svg>
        </div>
        <div class="w-100">
          <div class="d-flex justify-content-between">
            <span class="f-12 font-weight-600 ">
              Contact Available
            </span>
          </div>
        </div>
      </div>
    }
    @if(work_email.length) {
    <div class="mb-2">
      <span class="f-12 text-9696">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="16" height="16" rx="8" fill="#F2F2F2" />
          <path
            d="M5.9165 6.2428C5.9165 5.91128 6.0482 5.59333 6.28262 5.35891C6.51704 5.12449 6.83498 4.9928 7.1665 4.9928H9.0415C9.37302 4.9928 9.69097 5.12449 9.92539 5.35891C10.1598 5.59333 10.2915 5.91128 10.2915 6.2428V6.65946H5.9165V6.2428Z"
            stroke="#969696" stroke-width="0.833333" stroke-linecap="round" stroke-linejoin="round" />
          <path
            d="M3.83325 8.53442L7.89888 9.55088C7.96513 9.56755 8.03471 9.56755 8.10096 9.55088L12.1666 8.53442V11.2428C12.1666 11.3533 12.1227 11.4592 12.0445 11.5374C11.9664 11.6155 11.8604 11.6594 11.7499 11.6594H4.24992C4.13941 11.6594 4.03343 11.6155 3.95529 11.5374C3.87715 11.4592 3.83325 11.3533 3.83325 11.2428V8.53442Z"
            fill="#969696" stroke="#969696" stroke-width="0.833333" stroke-linecap="round" stroke-linejoin="round" />
          <path
            d="M12.1666 8.95109V7.07609C12.1666 6.96558 12.1227 6.8596 12.0445 6.78146C11.9664 6.70332 11.8604 6.65942 11.7499 6.65942H4.24992C4.13941 6.65942 4.03343 6.70332 3.95529 6.78146C3.87715 6.8596 3.83325 6.96558 3.83325 7.07609V8.95109"
            stroke="#969696" stroke-width="0.833333" stroke-linecap="round" stroke-linejoin="round" />
          <path
            d="M8.52067 8.11776C8.52067 8.25589 8.4658 8.38837 8.36812 8.48604C8.27045 8.58372 8.13797 8.63859 7.99984 8.63859C7.8617 8.63859 7.72923 8.58372 7.63155 8.48604C7.53388 8.38837 7.479 8.25589 7.479 8.11776C7.479 7.97962 7.53388 7.84715 7.63155 7.74947C7.72923 7.6518 7.8617 7.59692 7.99984 7.59692C8.13797 7.59692 8.27045 7.6518 8.36812 7.74947C8.4658 7.84715 8.52067 7.97962 8.52067 8.11776Z"
            fill="#969696" />
        </svg>

        <span class="font-weight-500 ml-2">Professional Email</span>
      </span>
    </div>
    }
    @for(work of work_email; track work) {
    <div class="mb-2 d-flex justify-content-between">
      <div class="d-flex">
        <span class="contact-cta mr-1">
          @if(work.enrichedvia) {
          <img
            [src]="'../../assets/icons/data-providers/' + work.enrichedvia + (work.enrichedvia ==='added-manually' ? work.type : '') + '.png'"
            class="mr-1" [alt]="work.enrichedvia" style="width: 15px;" matTooltip="{{work.enrichedvia}}"
            [matTooltipClass]="{ 'red-tooltip text-black': true }">
          }
        </span>
        <span class="mr-2 f-12">
          <a data-testid="auto-app-hire-contact-view-inbound-a-1" href="mailto: {{work}}" class="personal-email">{{work}}</a>
          @if(work.isprimary) {
          <span class="primary-tag ml-1 f-12 font-weight-500" style="color: #04363D;">Primary</span>
          }
        </span>
      </div>
      <div class="d-flex onHoverActions">
        <span (click)="copyToClipboard(work.contactdetail)" class="pointer">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path
              d="M4.0835 5.63851C4.0835 5.2259 4.2474 4.83019 4.53916 4.53843C4.83092 4.24667 5.22664 4.08276 5.63925 4.08276H10.6944C10.8987 4.08276 11.101 4.123 11.2898 4.20119C11.4785 4.27937 11.65 4.39397 11.7945 4.53843C11.939 4.6829 12.0536 4.8544 12.1317 5.04315C12.2099 5.23191 12.2502 5.43421 12.2502 5.63851V10.6937C12.2502 10.898 12.2099 11.1003 12.1317 11.289C12.0536 11.4778 11.939 11.6493 11.7945 11.7938C11.65 11.9382 11.4785 12.0528 11.2898 12.131C11.101 12.2092 10.8987 12.2494 10.6944 12.2494H5.63925C5.43494 12.2494 5.23264 12.2092 5.04389 12.131C4.85513 12.0528 4.68363 11.9382 4.53916 11.7938C4.3947 11.6493 4.2801 11.4778 4.20192 11.289C4.12374 11.1003 4.0835 10.898 4.0835 10.6937V5.63851Z"
              stroke="#484B59" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M2.34033 9.76325C2.16125 9.6615 2.0123 9.51416 1.90861 9.33619C1.80492 9.15822 1.7502 8.95597 1.75 8.75V2.91667C1.75 2.275 2.275 1.75 2.91667 1.75H8.75C9.1875 1.75 9.4255 1.97458 9.625 2.33333"
              stroke="#484B59" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>
      </div>
    </div>
    }

     @if(personal_email.length) {
    <div class="mb-2">
      <span class="f-12 text-9696">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="16" height="16" rx="8" fill="#F2F2F2"/>
<path d="M4.66659 11.6586C4.43742 11.6586 4.24131 11.5771 4.07825 11.414C3.9152 11.251 3.83353 11.0547 3.83325 10.8253V5.82528C3.83325 5.59611 3.91492 5.4 4.07825 5.23694C4.24159 5.07389 4.4377 4.99222 4.66659 4.99194H11.3333C11.5624 4.99194 11.7587 5.07361 11.922 5.23694C12.0853 5.40028 12.1669 5.59639 12.1666 5.82528V10.8253C12.1666 11.0544 12.0851 11.2507 11.922 11.414C11.7589 11.5774 11.5627 11.6589 11.3333 11.6586H4.66659ZM8.1095 8.65361C8.14756 8.64305 8.18395 8.62736 8.21867 8.60653L11.1666 6.76278C11.2221 6.72805 11.2638 6.68472 11.2916 6.63278C11.3194 6.58083 11.3333 6.52347 11.3333 6.46069C11.3333 6.3218 11.2742 6.21764 11.1562 6.14819C11.0381 6.07875 10.9166 6.08222 10.7916 6.15861L7.99992 7.90861L5.20825 6.15861C5.08325 6.08222 4.96172 6.08055 4.84367 6.15361C4.72561 6.22667 4.66659 6.32903 4.66659 6.46069C4.66659 6.53014 4.68047 6.59097 4.70825 6.64319C4.73603 6.69542 4.7777 6.73528 4.83325 6.76278L7.78117 8.60653C7.81589 8.62736 7.85242 8.64305 7.89075 8.65361C7.92909 8.66417 7.96547 8.6693 7.99992 8.66903C8.03436 8.66875 8.07089 8.66361 8.1095 8.65361Z" fill="#969696"/>
</svg>


        <span class="font-weight-500 ml-2">Personal Email</span>
      </span>
    </div>
    }
    @for(personal of personal_email; track personal) {
    <div class="mb-2 d-flex justify-content-between">
      <div class="d-flex">
        <span class="contact-cta mr-1">
          @if(personal.enrichedvia) {
          <img
            [src]="'../../assets/icons/data-providers/' + personal.enrichedvia + (personal.enrichedvia ==='added-manually' ? personal.type : '') + '.png'"
            class="mr-1" [alt]="personal.enrichedvia" style="width: 15px;" matTooltip="{{personal.enrichedvia}}"
            [matTooltipClass]="{ 'red-tooltip text-black': true }">
          }
        </span>
        <span class="mr-2 f-12">
          <a data-testid="auto-app-hire-contact-view-inbound-a-2" href="mailto: {{personal.contactdetail}}" class="personal-email">{{personal}}</a>
          @if(personal.isprimary) {
          <span class="primary-tag ml-1 f-12 font-weight-500" style="color: #04363D;">Primary</span>
          }
        </span>
      </div>
      <div class="d-flex">
        <span (click)="copyToClipboard(personal.contactdetail)" class="pointer">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path
              d="M4.0835 5.63851C4.0835 5.2259 4.2474 4.83019 4.53916 4.53843C4.83092 4.24667 5.22664 4.08276 5.63925 4.08276H10.6944C10.8987 4.08276 11.101 4.123 11.2898 4.20119C11.4785 4.27937 11.65 4.39397 11.7945 4.53843C11.939 4.6829 12.0536 4.8544 12.1317 5.04315C12.2099 5.23191 12.2502 5.43421 12.2502 5.63851V10.6937C12.2502 10.898 12.2099 11.1003 12.1317 11.289C12.0536 11.4778 11.939 11.6493 11.7945 11.7938C11.65 11.9382 11.4785 12.0528 11.2898 12.131C11.101 12.2092 10.8987 12.2494 10.6944 12.2494H5.63925C5.43494 12.2494 5.23264 12.2092 5.04389 12.131C4.85513 12.0528 4.68363 11.9382 4.53916 11.7938C4.3947 11.6493 4.2801 11.4778 4.20192 11.289C4.12374 11.1003 4.0835 10.898 4.0835 10.6937V5.63851Z"
              stroke="#484B59" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M2.34033 9.76325C2.16125 9.6615 2.0123 9.51416 1.90861 9.33619C1.80492 9.15822 1.7502 8.95597 1.75 8.75V2.91667C1.75 2.275 2.275 1.75 2.91667 1.75H8.75C9.1875 1.75 9.4255 1.97458 9.625 2.33333"
              stroke="#484B59" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>
      </div>
    </div>
    }
    @if(phones.length) {
    <div class="mb-2">
      <span class="f-12 text-9696">
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="16" height="16" rx="8" fill="#F2F2F2"/>
<path d="M10.2597 12.0777C9.93287 12.0777 9.47373 11.9595 8.78619 11.5753C7.95012 11.1065 7.30344 10.6736 6.47189 9.84426C5.67015 9.04302 5.28 8.52427 4.73395 7.53063C4.11708 6.40873 4.22223 5.82066 4.33978 5.56932C4.47977 5.26892 4.6864 5.08924 4.95348 4.91091C5.10518 4.81152 5.26571 4.72632 5.43305 4.65639C5.44979 4.64919 5.46537 4.64233 5.47926 4.63613C5.56215 4.59879 5.68774 4.54236 5.84681 4.60264C5.95297 4.64249 6.04775 4.72404 6.19611 4.87056C6.50036 5.17062 6.91613 5.83891 7.06952 6.16711C7.1725 6.3883 7.24065 6.53432 7.24082 6.69808C7.24082 6.88981 7.14437 7.03767 7.02732 7.19724C7.00538 7.22722 6.98362 7.25585 6.96252 7.28365C6.83509 7.4511 6.80713 7.49949 6.82554 7.58589C6.86289 7.75953 7.14135 8.27645 7.59899 8.73308C8.05662 9.18971 8.55863 9.45059 8.73294 9.48776C8.82303 9.50702 8.87243 9.47788 9.04523 9.34593C9.07001 9.32701 9.09547 9.30742 9.12209 9.28783C9.30059 9.15504 9.44158 9.06111 9.62879 9.06111H9.62979C9.79272 9.06111 9.9322 9.13177 10.1633 9.24831C10.4647 9.40036 11.1531 9.81077 11.455 10.1154C11.6018 10.2634 11.6837 10.3578 11.7237 10.4638C11.784 10.6234 11.7272 10.7485 11.6902 10.8322C11.684 10.8461 11.6772 10.8613 11.67 10.8782C11.5995 11.0453 11.5138 11.2055 11.4139 11.3568C11.236 11.6231 11.0556 11.8292 10.7545 11.9693C10.5999 12.0425 10.4307 12.0795 10.2597 12.0777Z" fill="#969696"/>
</svg>



        <span class="font-weight-500 ml-2">Contact Number</span>
      </span>
    </div>
  }
    @for(phone of phones; track phone) {
    <div class="d-flex justify-content-between">
      <div class="d-flex">
        <span class="mr-2 f-12">
          {{phone}}
          @if(phone.isprimary) {
          <span class="primary-tag ml-1 f-12 font-weight-500" style="color: #04363D;">Primary</span>
          }
        </span>
      </div>
      <div class="d-flex">
        <span (click)="copyToClipboard(phone)" class="pointer">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path
              d="M4.0835 5.63851C4.0835 5.2259 4.2474 4.83019 4.53916 4.53843C4.83092 4.24667 5.22664 4.08276 5.63925 4.08276H10.6944C10.8987 4.08276 11.101 4.123 11.2898 4.20119C11.4785 4.27937 11.65 4.39397 11.7945 4.53843C11.939 4.6829 12.0536 4.8544 12.1317 5.04315C12.2099 5.23191 12.2502 5.43421 12.2502 5.63851V10.6937C12.2502 10.898 12.2099 11.1003 12.1317 11.289C12.0536 11.4778 11.939 11.6493 11.7945 11.7938C11.65 11.9382 11.4785 12.0528 11.2898 12.131C11.101 12.2092 10.8987 12.2494 10.6944 12.2494H5.63925C5.43494 12.2494 5.23264 12.2092 5.04389 12.131C4.85513 12.0528 4.68363 11.9382 4.53916 11.7938C4.3947 11.6493 4.2801 11.4778 4.20192 11.289C4.12374 11.1003 4.0835 10.898 4.0835 10.6937V5.63851Z"
              stroke="#484B59" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M2.34033 9.76325C2.16125 9.6615 2.0123 9.51416 1.90861 9.33619C1.80492 9.15822 1.7502 8.95597 1.75 8.75V2.91667C1.75 2.275 2.275 1.75 2.91667 1.75H8.75C9.1875 1.75 9.4255 1.97458 9.625 2.33333"
              stroke="#484B59" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>
      </div>
    </div>
    }
  </div>

  @if(successMessage) {
  <ngb-alert class="ngb-alert" type="success" (close)="successMessage = ''">
    <span class="successCheck"><i class="fal fa-check"></i> </span>
    <span class="successmsg">{{ successMessage }}</span>
  </ngb-alert>
  }

  @if(errorMessage) {
  <ngb-alert class="ngb-alert" type="danger" (close)="errorMessage = ''">
    <span class="errorCheck"><i class="fal fa-times"></i></span>
    <span class="errormsg"> {{ errorMessage }} </span>
  </ngb-alert>
  }